<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 14091 14091"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="14091" height="14091" rx="1374" ry="1374"/>
  <path class="fil1" d="M1190 9361l11711 0 0 2357c0,628 -515,1142 -1142,1142l-9427 0c-628,0 -1142,-514 -1142,-1142l0 -2357z"/>
  <g id="_823548592">
   <path class="fil1" d="M6413 6653c-27,-89 -26,-358 -2,-467l1270 -7 5 477c-108,35 -879,12 -1109,14 -69,1 -109,10 -164,-17zm95 -1414c-70,-333 158,-602 429,-656 341,-68 593,169 646,428 145,709 -927,926 -1075,228zm-1780 136c119,1191 1208,2206 2563,2064 1218,-128 2193,-1195 2074,-2567 -104,-1190 -1218,-2215 -2571,-2069 -745,80 -1345,519 -1649,964 -207,300 -270,474 -366,808 -66,227 -75,566 -51,800z"/>
   <path class="fil1" d="M9606 4176c93,235 163,664 163,945 -1,408 -81,596 -164,944 531,-4 497,-53 644,132l208 264 756 1 -3 -2686 -758 4c-398,493 -146,392 -846,396z"/>
   <path class="fil1" d="M3646 6445c388,-494 183,-368 839,-382 -246,-898 -205,-1037 2,-1886 -613,-20 -450,114 -747,-263 -132,-169 -95,-138 -367,-138 -158,0 -316,1 -474,0 -44,187 -10,1072 -11,1326 0,451 0,902 1,1353l757 -10z"/>
   <path class="fil1" d="M3646 6445l-757 10c-1,-451 -1,-902 -1,-1353 1,-254 -33,-1139 11,-1326 -38,27 -39,-60 -30,153 30,678 -48,2001 5,2530 113,38 563,15 713,15 85,-10 34,-4 59,-29z"/>
   <path class="fil1" d="M6413 6653l8 -456 1245 0 2 455 -1255 1zm0 0c55,27 95,18 164,17 230,-2 1001,21 1109,-14l-5 -477 -1270 7c-24,109 -25,378 2,467z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'WaterPumping',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
.fil0 {fill:#00A0E3}
</style>
